import { render } from "./Todo.vue?vue&type=template&id=23b4f4fc"
const script = {}

import exportComponent from "/home/todo/todo/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__